// extracted by mini-css-extract-plugin
export default {"description":"SuccessMessage_description__aE-P9","content":"SuccessMessage_content__g23xa","button":"SuccessMessage_button__rWou3"};